import { render, staticRenderFns } from "./Trilha.vue?vue&type=template&id=42b37aff&lang=pug"
import script from "./Trilha.vue?vue&type=script&lang=js"
export * from "./Trilha.vue?vue&type=script&lang=js"
import style0 from "./Trilha.vue?vue&type=style&index=0&id=42b37aff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports